module.exports = __webpack_public_path__ + "img/small.f395aca8.jpg";